import { SearchInput } from "../../../components/SearchInput";
import Filters from "./Filters";
import typography from "../typography";
import plusIcon from "../../../assets/images/app/common/plus-icon.svg";

export default function Header({
    statusFilterVal = 1,
    filterUpdateHandler = () => {},
    searchTextVal = "",
    searchValUpdateHandler = () => {},
    onAddNotification = () => {},
}) {
    const statusFilterConfig = [
        {
            id: 1,
            title: typography.ALL,
        },
        {
            id: 2,
            title: typography.SENT,
        },
        {
            id: 3,
            title: typography.PENDING,
        },
    ];

    return (
        <div className="header-con-notification">
            <div className="filters-parent-con-notification">
                <div>
                    <Filters
                        activeTab={statusFilterVal}
                        tabClickHandler={filterUpdateHandler}
                        config={statusFilterConfig}
                        className="status-filter-con-notification"
                        label="Status"
                        filterType="status"
                    />
                </div>
                <div className="search-input-notification-con">
                    <SearchInput
                        placeholder={typography.SEARCH}
                        type="text"
                        onChange={(e) => searchValUpdateHandler(e)}
                        value={searchTextVal}
                    />
                </div>
            </div>
            <div className="add-notification-con-notification">
                <button
                    onClick={onAddNotification}
                    className="add-notification-btn"
                >
                    <img src={plusIcon} alt="plus icon" />
                    <span>{typography.ADD_NOTIFICATION}</span>
                </button>
            </div>
        </div>
    );
}
